module.exports = __webpack_public_path__ + "img/5_CN_ChineseMicrosite_Homepage_HeroImage.44bdb491.jpg";